
import Vue from 'vue'
import { authAxios } from '../utils'
import { Component } from 'vue-property-decorator'
import { VForm } from '../../global/vuetify.types'

interface ForgotPasswordData {
  email: string,
  type: string
}

@Component
export default class ForgotPasswordPage extends Vue {
  valid = false

  error: string | null = null

  formData: ForgotPasswordData = {
    email: '',
    type: 'agency'
  }

  success = false

  get emailRules() {
    return [
      (v: string) => !!v || 'Email is required',
      (v: string) => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,})+$/.test(v) || 'invalid email format'
    ]
  }

  get form() {
    return this.$refs.form as VForm
  }

  async submit() {
      if (this.form.validate()) {
        this.error = null
        try {
          await authAxios.post<{ success: boolean }>('/forgot-password', this.formData)
          this.success = true
        } catch (error) {
          this.error = this.error || 'There was an error processing your request. Please try again in a few minutes.'
        }
      }
    }
}
